import { render, staticRenderFns } from "./ClassManagementEnrollment.vue?vue&type=template&id=b1cea3d4"
import script from "./ClassManagementEnrollment.vue?vue&type=script&lang=js"
export * from "./ClassManagementEnrollment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports